import { Span, trace } from '@opentelemetry/api';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { W3CTraceContextPropagator } from '@opentelemetry/core';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { Resource } from '@opentelemetry/resources';
import {
  BatchSpanProcessor,
  WebTracerProvider,
} from '@opentelemetry/sdk-trace-web';

export function initOpentelemetry(kredivoUserId: string) {
  const serviceName = 'kredivo-web';
  const resource = Resource.default().merge(
    new Resource({
      'service.name': serviceName,
      'deployment.environment': IDC ? IDC + '-' + ENV : ENV,
    }),
  );

  const exporter = new OTLPTraceExporter({
    url: OPEN_TELEMETRY_URL,
    headers: {
      'api-igloo-trace-key': OPEN_TELEMETRY_API_KEY,
    },
    timeoutMillis: 5000,
  });

  const provider = new WebTracerProvider({
    resource,
    spanProcessors: [new BatchSpanProcessor(exporter)],
  });

  provider.register({
    contextManager: new ZoneContextManager(),
    propagator: new W3CTraceContextPropagator(),
  });

  trace.setGlobalTracerProvider(provider);

  // auto   instrumentation
  // @ts-ignore
  registerInstrumentations({
    instrumentations: [
      getWebAutoInstrumentations({
        '@opentelemetry/instrumentation-document-load': {
          applyCustomAttributesOnSpan: {
            documentLoad: (span: Span) => {
              if (kredivoUserId) {
                span.setAttribute('kredivo_user_id', kredivoUserId);
              }
            },
          },
        },
        '@opentelemetry/instrumentation-fetch': {
          propagateTraceHeaderCorsUrls: new RegExp(
            /iglooinsure\.com\/kredivo/i,
          ),
          applyCustomAttributesOnSpan: function (span: Span) {
            if (kredivoUserId) {
              span.setAttribute('kredivo_user_id', kredivoUserId);
            }
          },
        },
        '@opentelemetry/instrumentation-xml-http-request': {
          propagateTraceHeaderCorsUrls: new RegExp(
            /iglooinsure\.com\/kredivo/i,
          ),
          applyCustomAttributesOnSpan: function (span: Span) {
            if (kredivoUserId) {
              span.setAttribute('kredivo_user_id', kredivoUserId);
            }
          },
        },
      }),
    ],
    tracerProvider: provider,
  });
}
